export default "__VITE_ASSET__HEhHuQ7L__"